<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-导航组
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--背景颜色-->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button
            type="button"
            style="margin-left: 10px"
            @click.stop="onEditorResetColor(curItem.style, 'background', '#ffffff')">
            重置
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="设置：">
        <draggable
          class="wrapper"
          v-model="curItem.data"
          :options="{ animation: 120, filter: '.drag__nomove' }"
        >
          <div
            class="param-img-item"
            :key="index"
            v-for="(tabBar, index) in curItem.data"
          >
            <div class="delete-box">
              <i class="el-icon-delete-solid" @click="onEditorDeleleData(index, selectedIndex)"></i>
            </div>

            <!--背景颜色-->
            <el-form-item label="图标类型：">
              <!-- 选择图案还是icon -->
              <el-radio-group v-model="tabBar.icon_type">
                <el-radio :label="10">图标</el-radio>
                <el-radio :label="20">图片</el-radio>
              </el-radio-group>
            </el-form-item>

            <div v-if="tabBar.icon_type === 20">
              <div class="icon">
                <span class="key-name">默认：</span>
                <img
                  v-img-url="tabBar.imgUrl"
                  alt=""
                  @click="$parent.onEditorSelectImage(tabBar, 'imgUrl')"
                />
              </div>
              <div class="icon">
                <span class="key-name">激活：</span>
                <img
                  v-img-url="tabBar.selectImgUrl"
                  alt=""
                  @click="$parent.onEditorSelectImage(tabBar, 'selectImgUrl')"
                />
              </div>
            </div>
            <div v-else>
              <div class="url-box">
                <span class="key-name">底部图标：</span>
                <selectIcon :icon_text.sync="tabBar.icon"></selectIcon>
              </div>
            </div>

            <p class="tc gray9">建议尺寸48x48</p>
            <div class="url-box">
              <span class="key-name">文字内容：</span>
              <el-input v-model="tabBar.text"></el-input>
            </div>
            <div class="url-box">
              <span class="key-name">文字默认颜色：</span>
              <div class="d-s-c">
                <el-color-picker v-model="tabBar.color"></el-color-picker>
                <el-button
                  type="button"
                  style="margin-left: 10px"
                  @click.stop="onEditorResetColor(tabBar,'color','#ffffff')">
                  重置
                </el-button>
              </div>
            </div>
            <div class="url-box">
              <span class="key-name">文字选中颜色：</span>
              <div class="d-s-c">
                <el-color-picker v-model="tabBar.onColor"></el-color-picker>
                <el-button
                  type="button"
                  style="margin-left: 10px"
                  @click.stop="onEditorResetColor(tabBar,'color','#ffffff')">
                  重置
                </el-button>
              </div>
            </div>
            <div class="d-s-c">
              <div class="url-box flex-1">
                <span class="key-name">链接名称：</span>
                <el-input v-model="tabBar.name"></el-input>
              </div>
              <div class="url-box ml10">
                <el-button type="primary" @click="changeLink(index)"
                  >选择链接</el-button
                >
              </div>
            </div>
            <!--<div class="url-box">-->
            <!--  <span class="key-name">菜单效果: </span>-->
            <!--  <el-select-->
            <!--    v-model="tabBar.style"-->
            <!--    :label="tabBar.effectName"-->
            <!--    placeholder="请选择"-->
            <!--  >-->
            <!--    <el-option-->
            <!--      v-for="item in option"-->
            <!--      :key="item.value"-->
            <!--      :label="item.name"-->
            <!--      :value="item.value"-->
            <!--    >-->
            <!--    </el-option>-->
            <!--  </el-select>-->
            <!--</div>-->
          </div>
        </draggable>
        <div class="d-c-c">
          <el-button @click="onEditorAddData">添加一个</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink
    >
  </div>
</template>

<script>
import { deepClone } from "@/utils/base.js";
import Setlink from "@/components/setlink/Setlink";
import draggable from "vuedraggable";
import selectIcon from "@/components/page/selectIcon";
export default {
  components: {
    Setlink,
    draggable,
    selectIcon,
  },
  data() {
    return {
      itemData: [],
      option: [
        { name: "默认", value: "stand" },
        { name: "显眼", value: "stand_out" },
      ],
      /*是否选择链接*/
      is_linkset: false,
      index: null,
    };
  },
  props: ["curItem", "selectedIndex", "opts"],
  methods: {
    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.curItem.data[this.index].linkUrl = e.url;
        // this.curItem.data[this.index].name = e.name;
        this.curItem.data[this.index].name = "链接到" + " " + e.type + " " + e.name;
        if (e.appid) {
          this.curItem.data[this.index].appid = e.appid;
        }
      }
    },
    /* 新增 */
    onEditorAddData() {
      let self = this;

      if (this.curItem.data.length >= 5) {
        self.$message({
          message: "仅能添加5个底部菜单",
          type: "error",
        });
        return false;
      }
      // 新增data数据
      var newDataItem = deepClone(this.curItem.data[0]);
      this.curItem.data.push(newDataItem);
      this.curItem.style.rowsNum = this.curItem.data.length;
    },
    onEditorDeleleData(index, selectedIndex) {
      let self = this;
      if (this.curItem.data.length <= 1) {
        self.$message({
          message: "至少保留一个",
          type: "error",
        });
        return false;
      }
      this.curItem.data.splice(index, 1);
      this.curItem.style.rowsNum = this.curItem.data.length;
    },
    onEditorResetColor(holder, attribute, color) {
      holder[attribute] = color;
    },
  },
};
</script>

<style lang="scss" scoped>
.tabbar {
  overflow: visible !important;
}
.list {
  align-items: center !important;
}
.big {
  position: relative;
  bottom: 30px;
}
.big img {
  width: 50px !important;
  height: 50px !important;
}

.big .item-text{
  position: relative;
  top:17px;
}
.column-1 {
  display: flex !important;
}

.column-1 > .item {
  width: 100%;
}

.column-2 {
  display: flex !important;
}

.column-2 > .item {
  width: 50%;
}
.delete-box {
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/page/tabbar/diy/params/TabBar.vue